<div fxLayout="column" class="header">
  <div class="progress-bar">
    @if (loading | async) {
      <mat-progress-bar mode="indeterminate" class="background-color-white">
      </mat-progress-bar>
    }
  </div>
  <div class="main-bar pad-x-1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1rem">
    <a fxLayout="row" fxLayoutAlign="start center" (click)="toggle()" class="nav-button">
      <mat-icon class="slash" [svgIcon]="'slash'"></mat-icon>
      <span fxShow="true" fxHide.lt-md class="name">TACIT</span>
    </a>
    <div fxFlex fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem">
      <mat-icon class="title-icon">{{ icon | async }}</mat-icon>
      <div class="title color-white">{{ title | async }}</div>
    </div>
    <div fxShow="true" fxHide.lt-sm fxLayout="row" fxLayoutAlign="end center">
      <app-omni-search class="quick-button"></app-omni-search>
      <button fxShow="true" fxHide.lt-md mat-icon-button [routerLink]="'/tacit/dashboard'" class="quick-button">
        <mat-icon>dashboard</mat-icon>
      </button>
    </div>
  </div>
</div>